import { render, staticRenderFns } from "./CommonBannerNotification.vue?vue&type=template&id=60ec3654&scoped=true&"
import script from "./CommonBannerNotification.vue?vue&type=script&lang=js&"
export * from "./CommonBannerNotification.vue?vue&type=script&lang=js&"
import style0 from "./CommonBannerNotification.vue?vue&type=style&index=0&id=60ec3654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec3654",
  null
  
)

export default component.exports